<template>
  <div ref="collapseRef" style="display: flex; flex-direction: column">
    <div
      class="bap_collapse-collapsible"
      v-bind:style="{
        justifyContent: labelAlign,
        justifyItems: labelAlign,
        textAlign: labelAlign,
      }"
      v-on:click="handleCollapseToggle"
    >
      <div class="bap_collapse-collapsible-label">
        <slot name="label" v-if="hasLabelSlot"></slot>
        {{ !hasLabelSlot ? label : null }}
        &nbsp;
        <i
          class="fa fa-caret-down"
          v-bind:class="{ collapsed: !isCollapsed }"
        ></i>
      </div>
    </div>
    <transition
      name="roll"
      v-on:after-enter="scrollIntoView"
      v-on:before-leave="beforeLeave"
    >
      <div
        class="collapse-content"
        v-if="!isCollapsed"
        v-bind:style="{
          justifyContent: labelAlign,
          justifyItems: labelAlign,
          textAlign: labelAlign,
        }"
      >
        <slot />
      </div>
    </transition>
  </div>
</template>


<script>
export default {
  name: "BapCollapse",
  props: {
    label: {
      type: String,
      default: "Expand",
    },
    labelAlign: {
      required: false,
      type: String,
      validator: (value) => {
        // The value must match one of these strings
        return ["start", "center", "end"].includes(value);
      },
    },
  },
  data() {
    return {
      isCollapsed: true,
    };
  },
  computed: {
    hasLabelSlot() {
      return !!(this.$slots && this.$slots.label);
    },
  },
  methods: {
    handleCollapseToggle: function () {
      this.isCollapsed = !this.isCollapsed;
    },
    scrollIntoView: function () {
      this.$refs.collapseRef.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    },
    beforeLeave: function () {
      window.scrollTo({
        top: 100,
        left: 100,
        behavior: "smooth",
      });
    },
  },
};
</script>

<style scoped>
.roll-enter-active,
.roll-leave-active {
  transition: all 0.2s;
  max-height: 230px;
}
.roll-enter,
.roll-leave-to {
  opacity: 0;
  max-height: 0px;
}

.bap_collapse-collapsible {
  color: #337ab7;
  display: inline-flex;
  align-items: baseline;
}

.bap_collapse-collapsible-label {
  display: flex;
  align-items: center;
}

.bap_collapse-collapsible i:hover,
.bap_collapse-collapsible-label:hover {
  cursor: pointer;
  color: #23527c;
}

.bap_collapse-collapsible-label:hover {
  transform: 0.5s scale(1.15);
}

.bap_collapse-collapsible i {
  text-decoration: none;
  transition: transform 0.15s ease-out;
  transform-origin: center;
  transform: rotate(0deg);
  margin-top: 2px;
}

.bap_collapse-collapsible i.collapsed {
  transform: rotate(-180deg);
}
</style>
